import React from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import cx from 'classnames';

import DefaultQVContent from './components/DefaultQVContent';
import FinanceQVContent from './components/FinanceQVContent';

import { isDefaultQVSelector, isFinanceQVSelector } from '../selectors';

const CompanyQuickView = ({ onClose }) => {
  const isFinanceQV = useSelector(isFinanceQVSelector);
  const isDefaultQV = useSelector(isDefaultQVSelector);

  return (
    <div
      className={cx('company-quick-view', {
        'company-quick-view--default': isDefaultQV,
        'company-quick-view--finance': isFinanceQV,
      })}
    >
      {isDefaultQV && <DefaultQVContent onClose={onClose} />}
      {isFinanceQV && <FinanceQVContent onClose={onClose} />}
    </div>
  );
};

CompanyQuickView.propTypes = {
  onClose: T.func.isRequired,
};

export default CompanyQuickView;
